import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  AfterViewInit,
  Renderer2,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzDropdownMenuComponent, NzContextMenuService } from 'ng-zorro-antd/dropdown';
import { ServerService } from '../../../customer-service/server.service';
import { tap, takeUntil } from 'rxjs';
import { Subject } from 'rxjs';
import { ModalService } from '@root/router/index/modal.service';
import _ from 'lodash';
import * as moment from 'moment';
import { TranslateService } from '@root/shared/service/translate.service';
import { DateService } from '@root/shared/service/date.service';
type Position = 'left' | 'right';

@Component({
  selector: 'host-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss'],
})
export class MessageItemComponent implements OnInit, AfterViewInit, OnDestroy {
  _message;
  checking = false;
  @Output() onClickGuide = new EventEmitter<string>();
  @Input() size: 'small' | 'normal' = 'normal';
  @Input() position: Position = 'left';
  @Input() displayTranslate = false;
  @Input() userInfo;
  @Input()
  get message() {
    return this._message;
  }
  set message(value) {
    const m = value.message;
    const { type, content, extra } = m;

    let html = '' + content;
    if (type === 'label') {
      html = `<span>${this.dateService.format(content, ['MD', 'hm'])}</span>`;
      if (this.size === 'normal') {
        html = `${html}<br><span>入口：${extra.entry}</span>`;
      }
    } else if (type === 'text') {
      html = html.replace(/\n|\r|(\r\n)/g, '<br>');
      if (extra && extra.url_list && !extra.link_list) {
        _.forEach(extra.url_list, (u) => {
          html = html.replace(u, `<a href="${u}" target="_blank" style="word-break: break-all">${u}</a>`);
        });
      }
      if (extra && extra.link_list) {
        // /{#link\|\|(.*?)\|\|(.*?)#}/

        const linkReg = /{#link\|\|(.*?)\|\|(.*?)#}/g;
        html = html.replace(linkReg, '<a href="$2" target="_blank">$1</a>');
        // let regResult;
        // while ((regResult = linkReg.exec(html)) !== null) {
        //   console.log('link reg: ', linkReg.exec(html));
        // }
      }
      if (extra && extra.guide_list) {
        const guideReg = /{#guide\|\|(.*?)#}/g;
        html = html.replace(guideReg, `<a class="guide-dyn" data-type="guide" data-content="$1">$1</a>`);
      }
    }
    this._message = value;
    _.assign(this._message, { html, checked: false });
  }
  get type() {
    return _.get(this.message, 'message.type');
  }

  private checkStatus$ = this.serverService.checkStatus$.pipe(
    tap((status) => {
      this.checking = status;
      if (!status) {
        this.message.checked = false;
      }
    })
  );

  private destroy$ = new Subject();
  private clipboard;
  constructor(
    private contextMenuService: NzContextMenuService,
    private serverService: ServerService,
    private globalModalService: ModalService,
    private messageService: NzMessageService,
    private render: Renderer2,
    private elementRef: ElementRef,
    private translate: TranslateService,
    private dateService: DateService
  ) {
    this.checkStatus$.pipe(takeUntil(this.destroy$)).subscribe();
  }
  ngOnInit() {}

  ngAfterViewInit() {
    this.listenDynElementEvent();
  }

  onContextMenu(event, menu: NzDropdownMenuComponent) {
    this.contextMenuService.create(event, menu);

    if (!this.clipboard) {
      this.clipboard = new ClipboardJS('.copy-content');
      this.clipboard.on('success', (e) => {
        // this.messageService.success('复制成功！');
        this.messageService.success(this.translate.syncGet('success.copy'));
      });
    }
  }

  onCheck(id?) {
    this.serverService.updateCheckStatus(true);
    this.message.checked = true;
  }
  // onClickImage(url) {
  //   this.globalModalService.displayImageMagnifier(url);
  // }

  private listenDynElementEvent() {
    const element = this.elementRef.nativeElement;
    this.render.listen(this.elementRef.nativeElement, 'click', (e) => {
      const target = e.target as HTMLElement;
      const dataset = target.dataset;

      if (dataset.type === 'guide') {
        this.onClickGuide.emit(dataset.content);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
    this.clipboard && this.clipboard.destroy();
  }
}
